import LazyHydratedAdSenseSlot from 'components/AdSlots/AdSenseSlot/LazyHydratedAdSenseSlot';

const AdPlaceholder = () => <LazyHydratedAdSenseSlot slot="SIDEBAR_300x250" />;

export default AdPlaceholder;
